<template>
    <div class="acountStatus"> 
        <div class="mainTitle text-center my-3">
            <h3 class="mb-4">{{ $t('bonusList') }}</h3>
            <message-component :message="response_msg" :messageType="msg_type"></message-component>
        </div>
        <div class="whiteBG radius pt-3">
            <div class="d-flex flex-wrap tabcenter justify-content-between border-bottom pb-3 px-3 mb-2">
                <div></div>
                <div class="requestbtn d-flex align-items-center">
                    <filter-component></filter-component>    
                </div>
            </div>
            <div class="inMiddle-area table-responsive">
                <table class="table pmmTable">
                    <thead>
                        <tr>
                            <th>{{ $t('accountId') }}</th>
                            
                            <th>{{ $t('amount') }}</th>
							<th>{{ $t('currency') }}</th>
                            <th>{{ $t('bonusType') }}</th>
                            <th>{{ $t('created') }}</th>
                        </tr>
                    </thead>
                    <tbody v-if="(!pageLoader && bonusList != '' && bonusList.totalRecords > 0)">
                        <tr v-for="list in bonusList.records" >
                            <td>{{list.account_id}} </td>
                            <td>{{list.amount}}</td>
                            <td>{{list.currency}}</td>
                            <td>{{bonusType[list.bonustype]}}</td>
                            <td>{{list.created | moment("DD MMMM YYYY")}}</td>
                        </tr>
                    </tbody>
                    <loader-component :pageloader_value="pageLoader" :type="'table'" :colspan="col_span" :list="bonusList" v-else></loader-component>
                </table> 
            </div> 
        </div> 
        <pagination :getList="bonusList" :limit="pageLimit" v-if="bonusList.totalRecords > 0"></pagination>
    </div> 
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
    export default {
        name: 'Bonus-List',
        mixins: [fxViewMixins],
        data() {
            return {
                //===========prop in loader component=======
                col_span : 5,
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                loaderFuncRun : '1',
                //==========================================
                pageLimit : '15',
                search : '',
                page : '1'
            }
        },
        methods:{
            listing(){
                let inputJson = {
                    'globalParams' : {
                        filter: {},
                        sort: [],
                        search: this.search,
                        page: this.page,
                        perPage: parseInt(this.pageLimit),
                    } ,'localParams' : {'parameter' : this , 'loaderFuncRun' : this.loaderFuncRun}
                }
                this._runGetBonusList(inputJson)
            }
        },
        created(){
            if(this.$store.getters[Const.GET_BONUS_LIST] != ''){
                this.loaderFuncRun = '0'
            }
            this.listing()
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/bonus/bonus_list.vue